import { Icon20CloudArrowUpOutline, Icon20FolderSimplePlusOutline, Icon20SmartphoneOutline } from '@vkontakte/icons';
import React from 'react';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { closeCommonWhatsNewDialog, renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { renderWebAutoUploadFakedoorModal } from 'reactApp/ui/WebAutoUploadFakedoor/WebAutoUploadFakedoorModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './WebAutoUploadModal.css';
interface Params {
    complete: () => void;
}

const sendRadar = createDwhTemplatedSender({ eventCategory: 'modal_autoupload', replacementSymbol: '_' });

export const renderWebAutoUploadModal = ({ complete }: Params) => {
    const isDarkTheme = isDarkThemeModeEnabled();

    const title = 'Автозагрузка файлов с компьютера в Облако';
    const primaryButtonText = 'Попробовать';
    const secondaryButtonText = 'Не интересно';

    const bulletedContent = [
        { icon: <Icon20FolderSimplePlusOutline />, text: 'Работайте с папкой на компьютере – в Облаке будет последняя версия' },
        { icon: <Icon20CloudArrowUpOutline />, text: 'Изменения сохранятся сами – не придётся помнить и тратить время' },
        { icon: <Icon20SmartphoneOutline />, text: 'Сможете открывать файлы с любого устройства' },
    ];

    const onShow = () => {
        sendRadar({
            action: 'show',
        });
    };

    const onClick = () => {
        sendRadar({
            action: 'click',
        });

        closeCommonWhatsNewDialog();
        renderWebAutoUploadFakedoorModal();
        complete();
    };

    const onClose = () => {
        sendRadar({
            action: 'close',
        });

        closeCommonWhatsNewDialog();
        complete();
    };

    renderCommonWhatsNewDialog({
        dialogSize: 'large',
        buttonTheme: 'vk',
        title,
        primaryButtonText,
        secondaryButtonText,
        closeBySecondaryButton: true,
        bulletedContent,
        hideImage: true,
        imageUrl: '',
        showVideo: true,
        loopVideo: true,
        videoUrl: {
            webm: `${cdnPackagesUrl}/static/cloud/webAutoUpload/fakedoor/modal${isDarkTheme ? '-dark' : ''}.webm`,
            mp4: `${cdnPackagesUrl}/static/cloud/webAutoUpload/fakedoor/modal${isDarkTheme ? '-dark' : ''}.mp4`,
        },
        videoWrapperClass: styles.videoWrapper,
        onClick,
        onClose,
        onShow,
        closeIconClassName: styles.closeIcon,
    });
};
